import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { styles } from '../assets/styles';

const lightenColor = (color, percent) => {
  const num = parseInt(color.slice(1), 16);
  const amt = Math.round(2.55 * percent);
  const R = (num >> 16) + amt;
  const G = ((num >> 8) & 0x00ff) + amt;
  const B = (num & 0x0000ff) + amt;
  const newColor = `#${(
    0x1000000
    + (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000
    + (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100
    + (B < 255 ? (B < 1 ? 0 : B) : 255)
  )
    .toString(16)
    .slice(1)}`;
  return newColor;
};

export function PokemonInfo({ pokemonInfo }) {
  const {
    name,
    type1,
    type2,
    gen,
    weight,
    height,
    total_stats,
    sprite,
    ability1,
    ability2,
    ability3,
  } = pokemonInfo;
  const [showInfo, setShowInfo] = useState(false);

  const [colorGeneration, setColorGeneration] = useState(pokemonInfo.colorGeneration);
  const [colorTypes, setColorTypes] = useState(pokemonInfo.colorTypes);
  const [colorWeight, setColorWeight] = useState(pokemonInfo.colorWeight);
  const [colorHeight, setColorHeight] = useState(pokemonInfo.colorHeight);
  const [colorTotalStats, setColorTotalStats] = useState(pokemonInfo.colorTotalStats);
  const [colorAbilities, setColorAbilities] = useState(pokemonInfo.colorAbilities);

  const handleMouseOverGen = () => {
    const newColor = lightenColor(pokemonInfo.colorGeneration, 10); // aumenta el porcentaje para aclarar más el color
    setColorGeneration(newColor);
  };

  const handleMouseOutGen = () => {
    setColorGeneration(pokemonInfo.colorGeneration);
  };

  const handleMouseOverTypes = () => {
    const newColor = lightenColor(pokemonInfo.colorTypes, 10); // aumenta el porcentaje para aclarar más el color
    setColorTypes(newColor);
  };

  const handleMouseOutTypes = () => {
    setColorTypes(pokemonInfo.colorTypes);
  };

  const handleMouseOverWeight = () => {
    const newColor = lightenColor(pokemonInfo.colorWeight, 10); // aumenta el porcentaje para aclarar más el color
    setColorWeight(newColor);
  };

  const handleMouseOutWeight = () => {
    setColorWeight(pokemonInfo.colorWeight);
  };

  const handleMouseOverHeight = () => {
    const newColor = lightenColor(pokemonInfo.colorHeight, 10); // aumenta el porcentaje para aclarar más el color
    setColorHeight(newColor);
  };

  const handleMouseOutHeight = () => {
    setColorHeight(pokemonInfo.colorHeight);
  };

  const handleMouseOverTotalStats = () => {
    const newColor = lightenColor(pokemonInfo.colorTotalStats, 10); // aumenta el porcentaje para aclarar más el color
    setColorTotalStats(newColor);
  };

  const handleMouseOutTotalStats = () => {
    setColorTotalStats(pokemonInfo.colorTotalStats);
  };

  const handleMouseOverAbilities = () => {
    const newColor = lightenColor(pokemonInfo.colorAbilities, 10); // aumenta el porcentaje para aclarar más el color
    setColorAbilities(newColor);
  };

  const handleMouseOutAbilities = () => {
    setColorAbilities(pokemonInfo.colorAbilities);
  };

  const { arrowWeight } = pokemonInfo;
  const { arrowHeight } = pokemonInfo;
  const { arrowTotalStats } = pokemonInfo;

  useEffect(() => {
    setShowInfo(true);
  }, []);

  return (
    <Box>
      <div className="pokemon-info-container" style={styles.pokeInfoContainer}>
        <div style={styles.pokeInfoNameSpriteContainer}>
          <h2
            className={`pokemon-info-name ${showInfo ? 'fade-in' : ''}`}
            style={styles.pokeInfoName}
          >
            {name}
          </h2>

          <img
            className={`pokemon-sprite ${showInfo ? 'fade-in' : ''}`}
            style={styles.pokeInfoSprite}
            src={sprite}
            alt="Pkmn sprite"
          />
        </div>

        <div style={styles.pokeInfoBoxesContainer}>
          <div
            className={`pokemon-info-gen ${showInfo ? 'fade-in-box show' : ''}`}
            style={styles.pokeInfoMargin}
          >
            {showInfo && (
              <p
                className="pokemon-gen"
                style={{
                  ...styles.p,
                  backgroundColor: `${colorGeneration}`,
                }}
                onMouseOver={handleMouseOverGen}
                onMouseOut={handleMouseOutGen}
              >
                {gen}
              </p>
            )}
          </div>

          <div
            className={`pokemon-info-types ${showInfo ? 'fade-in-box2 show' : ''}`}
            style={styles.pokeInfoTypes}
          >
            {showInfo && (
              <p
                style={{ ...styles.p, backgroundColor: `${colorTypes}` }}
                onMouseOver={handleMouseOverTypes}
                onMouseOut={handleMouseOutTypes}
              >
                {type1}
                {type2 && ','}
                {' '}
                <br />
                {' '}
                {type2}
              </p>
            )}
          </div>

          <div
            className={`pokemon-info-abilities ${showInfo ? 'fade-in-box3 show' : ''}`}
            style={styles.pokeInfoAbilities}
          >
            {showInfo && (
              <p
                style={{
                  ...styles.p,
                  backgroundColor: `${colorAbilities}`,
                  fontSize: '13px',
                }}
                onMouseOver={handleMouseOverAbilities}
                onMouseOut={handleMouseOutAbilities}
              >
                {ability1}
                {ability2 && ','}
                {ability2 ? <br /> : null}
                {ability2}
                {ability2 && ability3 && ','}
                {ability3 ? <br /> : null}
                {ability3}
              </p>
            )}
          </div>

          <div
            className={`pokemon-info-weight ${showInfo ? 'fade-in-box4 show' : ''}`}
            style={styles.pokeInfoMargin}
          >
            {showInfo && (
              <p
                style={{ ...styles.p, backgroundColor: `${colorWeight}` }}
                onMouseOver={handleMouseOverWeight}
                onMouseOut={handleMouseOutWeight}
              >
                {weight}
                {' '}
                kg
                {arrowWeight}
              </p>
            )}
          </div>

          <div
            className={`pokemon-info-height ${showInfo ? 'fade-in-box5 show' : ''}`}
            style={styles.pokeInfoMargin}
          >
            {showInfo && (
              <p
                style={{ ...styles.p, backgroundColor: `${colorHeight}` }}
                onMouseOver={handleMouseOverHeight}
                onMouseOut={handleMouseOutHeight}
              >
                {height}
                {' '}
                m
                {arrowHeight}
              </p>
            )}
          </div>

          <div
            className={`pokemon-info-stats ${showInfo ? 'fade-in-box6 show' : ''}`}
            style={styles.pokeInfoMargin}
          >
            {showInfo && (
              <p
                style={{
                  ...styles.p,
                  backgroundColor: `${colorTotalStats}`,
                }}
                onMouseOver={handleMouseOverTotalStats}
                onMouseOut={handleMouseOutTotalStats}
              >
                {total_stats}
                {arrowTotalStats}
              </p>
            )}
          </div>
        </div>
      </div>
    </Box>
  );
}

export function PokemonInfoCries({ pokemonInfoCries }) {
  const { name, sprite, id } = pokemonInfoCries;
  const [showInfo, setShowInfo] = useState(false);
  const [colorName, setColorName] = useState(pokemonInfoCries.colorName);

  const handleMouseOver = () => {
    const newColor = lightenColor(pokemonInfoCries.colorName, 10); // aumenta el porcentaje para aclarar más el color
    setColorName(newColor);
  };

  const handleMouseOut = () => {
    setColorName(pokemonInfoCries.colorName);
  };

  useEffect(() => {
    setShowInfo(true);
  }, []);

  return (
    <Box sx={styles.pokeInfoMarginTop}>
      <div
        className={`pokemon-info-name ${showInfo ? 'fade-in show' : ''}`}
        style={styles.pokeInfoCenter}
      >
        {showInfo && (
          <p
            className="pokemon-gen"
            style={{
              ...styles.pCries,
              backgroundColor: `${colorName}`,
            }}
            onMouseOver={handleMouseOver}
            onMouseOut={handleMouseOut}
          >
            {name}
            {' '}
            <br />
            {' '}
            <img src={sprite} style={styles.pokeInfoImg} />
          </p>
        )}
      </div>
    </Box>
  );
}

export function PokemonInfoEmoji({ pokemonInfoEmoji }) {
  const { name, sprite, id } = pokemonInfoEmoji;
  const [showInfo, setShowInfo] = useState(false);
  const [colorName, setColorName] = useState(pokemonInfoEmoji.colorName);

  const handleMouseOver = () => {
    const newColor = lightenColor(pokemonInfoEmoji.colorName, 10); // aumenta el porcentaje para aclarar más el color
    setColorName(newColor);
  };

  const handleMouseOut = () => {
    setColorName(pokemonInfoEmoji.colorName);
  };

  useEffect(() => {
    setShowInfo(true);
  }, []);

  return (
    <Box sx={styles.pokeInfoMarginTop}>
      <div
        className={`pokemon-info-name ${showInfo ? 'fade-in show' : ''}`}
        style={styles.pokeInfoCenter}
      >
        {showInfo && (
          <p
            className="pokemon-gen"
            style={{
              ...styles.pCries,
              backgroundColor: `${colorName}`,
            }}
            onMouseOver={handleMouseOver}
            onMouseOut={handleMouseOut}
          >
            {name}
            {' '}
            <br />
            {' '}
            <img src={sprite} style={styles.pokeInfoImg} />
          </p>
        )}
      </div>
    </Box>
  );
}
